import { Box } from '@televet/kibble-ui/build/chakra';
import { Task } from 'pages/Tasks/types';
import React from 'react';
import { TaskType } from 'shared/types/graphql';
import TaskDetailAutomationRun from './TaskDetailAutomationRun';
import TaskDetailAutomationRunAppointment from './TaskDetailAutomationRunAppointment';
import TaskDetailCustom from './TaskDetailCustom';
import TaskDetailWidgetRequest from './TaskDetailWidgetRequest';

type TaskDetailProps = {
  task: Task;
  borderLeftColor?: string;
  showAppointmentDetails?: boolean;
};

export const TaskDetail = ({ task, borderLeftColor, showAppointmentDetails }: TaskDetailProps): JSX.Element => {
  return (
    <Box>
      {task.type === TaskType.WidgetRequest && (
        <TaskDetailWidgetRequest
          widgetRequestId={task.widgetRequestId}
          phoneNumber={task.clinicPetParent?.phoneNumber}
          borderLeftColor={borderLeftColor}
        />
      )}
      {task.type === TaskType.Automation &&
        (showAppointmentDetails ? (
          <TaskDetailAutomationRunAppointment
            automationRunId={task.automationRunId}
            borderLeftColor={borderLeftColor}
            taskId={task.id}
          />
        ) : (
          <TaskDetailAutomationRun task={task} />
        ))}
      {task.type === TaskType.Custom && <TaskDetailCustom task={task} />}
    </Box>
  );
};
